<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">Edit Role</h3>
            </div>
            <v-form class="v-form-body" ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <label class="form-control-label">
                    Role
                    <span class="red--text">*</span>
                  </label>
                  <v-text-field
                    v-model="role.name"
                    placeholder="Name"
                    :rules="[v => !!v || 'Name is required!']"
                    required
                    solo
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-card-title class="pt-8">
                    <h4>Active</h4>
                    <v-switch class="pl-4 pt-3 mt-0" v-model="role.active" inset></v-switch>
                  </v-card-title>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-card-title class="pt-8">
                    <h4>Visible to Doctor?</h4>
                    <v-switch class="pl-4 pt-3 mt-0" v-model="role.show" inset></v-switch>
                  </v-card-title>
                </v-col>
              </v-row>
              <card shadow>
                <div class="permission-header">
                  <div>
                    <h3 class="permission-header-name">Permissions</h3>
                  </div>
                </div>
                <div class="card-body">
                  <!-- <v-row class="ma-0">
                    <v-col cols="12" class="pb-0 pt-5">
                     <span class="font-weight-medium">
                        Menu(module) access
                     </span>
                     <v-divider class="ma-0 mt-1"></v-divider>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0">
                    <v-col cols="3">
                     <v-checkbox
                      v-model="allModulesSelected"
                      @change="
                        selectAllModules(
                          $event,
                          modulesArray
                        )
                      "
                      label="Select All"
                    ></v-checkbox>
                    </v-col>
                    <v-col
                      cols="3"
                      v-for="(moduleObj, index) in modulesArray"
                      :key="index"
                    >
                      <v-checkbox
                          class="check-bx"
                          v-model="role.modules[0][index]"
                          :label="moduleObj.title"
                        ></v-checkbox>
                    </v-col>
                  </v-row> -->
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-expansion-panels focusable>
                        <v-expansion-panel v-for="(module,moduleKey) in apisListArray" :key="moduleKey">
                          <v-form>
                            <v-expansion-panel-header>{{module.title}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col cols="4">
                                   <v-checkbox
                                    v-model="selectAllField[moduleKey]"
                                    @change="
                                      selectAll(
                                        $event,
                                        moduleKey,
                                        apisListArray[moduleKey].apis
                                      )
                                    "
                                    label="Select All"
                                  ></v-checkbox>
                                </v-col>
                                <v-col cols="4" v-for="(api,j) in apisListArray[moduleKey].apis" :key="j">
                                  <v-checkbox
                                    class="check-bx"
                                    v-model="role.permissions[moduleKey]"
                                    :label="`${api.title}`"
                                    :value="`${api.path}`"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-form>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </div>
              </card>
              <v-col class="text-right pt-8 pb-3 px-0" cols="12">
                <v-btn color="#989898" class="mr-4 white--text" @click="cancel">Cancel</v-btn>
                <v-btn
                  :disabled="!valid"
                  color="#344452"
                  class="white--text"
                  :loading="loading"
                  @click="validate"
                >Update</v-btn>
              </v-col>
            </v-form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import { RoleService } from "@/services";
import { MODULE_API_LIST } from "@/constants";

export default {
  name: "EditRole",
  components: {
    CommonSection,
  },
  data: function () {
    return {
      valid: true,
      modules: {},
      loading: false,
      modulesArray: [],
      apisListArray: [],
      role: {
        name: null,
        permissions: {},
        active: false,
        show: false,
        //modules: [],
      },
      selectAllField: [],
      allModulesSelected:true
    };
  },
  watch:{
    'role.permissions': {
      handler: function(newValue) {
        let permissionsArray = newValue;
        for (const [itemIndex, apisData] of Object.entries(permissionsArray)) {
          this.selectAllField[itemIndex] = false
          if(this.apisListArray[itemIndex].apis.length==apisData.length){
            this.selectAllField[itemIndex] = true
          }
        }
      },
      deep: true
    },
    "role.modules": {
      handler: function (newModules) {
        let selectedModuleCounts = 0
        for (const [module] of Object.entries(newModules[0])) {
         if(module) selectedModuleCounts++
        }
        this.allModulesSelected = (selectedModuleCounts == Object.keys(this.modulesArray).length) ? true : false;
        
        let updatedModulesVal = newModules[0];
        for (const [moduleKey, apiList] of Object.entries(MODULE_API_LIST[0])) {
          for (const [permissionKey, apisArray] of Object.entries(apiList[0])) {
            if (updatedModulesVal[moduleKey]) {
              let permissionArray = this.role.permissions[permissionKey];
              permissionArray =
                permissionArray.length > 0
                  ? permissionArray.concat(apisArray)
                  : apisArray;
                  if(this.role.permissions[permissionKey].length==0){
                    this.$set(
                      this.role.permissions,
                      permissionKey,
                      permissionArray
                    );
                  }
            } else {
              if(this.role.permissions[permissionKey]){
                this.$set(this.role.permissions, permissionKey, []);
              }
            }
          }
        }
      },
      deep: true,
    },
  },
  async mounted() {
    const routeList = await RoleService.routeList();
    this.modulesArray =
      routeList.data.moduleList.modules.length > 0
        ? routeList.data.moduleList.modules[0]
        : [];
    this.apisListArray = routeList.data.apiList ? routeList.data.apiList : [];
    
    //this.role.modules = [];
    let modulestObj = {};
    for (const [key, module] of Object.entries(this.modulesArray)) {
        modulestObj[key] = module.value;
    }
    //this.role.modules.push(modulestObj)

    this.role.permissions = [];
    let apisListObj = {};
    for (const [itemIndex] of Object.entries(this.apisListArray)) {
      apisListObj[itemIndex] = [];
    }
    this.role.permissions = apisListObj;

    const roleDetail = await RoleService.getRole(this.$route.params.id);

    this.role.permissions=roleDetail.data.data[0].permissions;
    //this.role.modules = roleDetail.data.data[0].modules;
    this.role.name = roleDetail.data.data[0].name;
    this.role.active = roleDetail.data.data[0].active;
    this.role.show = roleDetail.data.data[0].show;
  },
  methods: {
    selectAllModules(event){
      let temp = {}
      for (const [key] of Object.entries(this.role.modules[0])) {
        temp[key] = (event) ? true : false;
      }
      this.$set(this.role.modules,0,temp)
    },
    async validate() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          const response = await RoleService.updateRole({
            id: this.$route.params.id,
            object: this.role,
          });
          if (response) {
            this.loading = false;
            this.$router.push("/roles");
            this.$store.dispatch("user/setSnack", "Role Updated.");
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
        }
      }
    },
    selectAll(event,itemIndex, items) {
      let selectedAll = [];
      if(!event){
        this.$set(this.role.permissions, itemIndex, []);
        return
      }
      for (let i in items) {
        let isExists = this.role.permissions[itemIndex].includes(items[i].path);
        if (!isExists) {
          selectedAll[i] = items[i].path
        } else {
          const index = this.role.permissions[itemIndex].findIndex(
            (x) => x == items[i].path
          );
          if (this.selectAllField[itemIndex] == true) {
            selectedAll[i] = items[i].path
            this.$set(this.role.permissions, itemIndex, selectedAll);
          } else {
            this.role.permissions.splice(index, 1);
          }
        }
      }
      this.role.permissions[itemIndex] = selectedAll;
    },
    cancel() {
      this.$router.push("/roles");
    },
  },
};
</script>
